import React, {useEffect, useState} from 'react';
import {SectionsProps} from "../../../../../models";
import {Formik, FieldArray, Field} from "formik";
import {BusinessFormProductServiceValidation} from "../AddBusinessValidation";
import {Button, InputField, TextAreaField} from "../../../../../components";

export const ProductsAndServices: React.FC<SectionsProps> = ({
                                                                 changeStep,
                                                                 setNewBusinessInfo,
                                                                 newBusinessInfo,
                                                                 setSectionName
                                                             }) => {

    const [optionList] = useState([
        "product",
        "service"
    ])

    useEffect(() => {
        setSectionName('Products / Services')
    }, [setSectionName]);

    const [initialValues] = useState({
        products_services: newBusinessInfo?.products_services
    });


    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({
            ...prevInfo,
            products_services: values.products_services
        }))

        changeStep && changeStep("next")
        setSubmitting(false);
    }
    return (
        <div className={'add-business-section products-service'}>
            <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. </p>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={BusinessFormProductServiceValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div className={'add-business-section_input'}>
                            <FieldArray
                                name={"products_services"}
                            >
                                {
                                    (fieldArrayProps) => {
                                        const {push, remove, form} = fieldArrayProps
                                        const {products_services} = values

                                        return (
                                            <div className="products-service_items">
                                                {products_services.length > 0 &&
                                                products_services.map((item: any, index: any) => (
                                                    // <div key={'p_s_i_' + index + item.type}
                                                    <div className={'products-service_items_item'} key={index}>
                                                        <div className={'products-service_items_heading'}>
                                                            <h2>Item #: {index + 1}</h2>
                                                            <div className="remove" onClick={() => remove((index))}> -
                                                                Remove Item
                                                            </div>

                                                        </div>
                                                        <div className={'add-business-section_input_radio'}>
                                                            <span>Product or Service?:</span>
                                                            <Field
                                                                name={`products_services[${index}].type`}
                                                                id={`products_services[${index}].type`}
                                                                as="select"
                                                                onBlur={handleBlur}
                                                                // error={errors.products_services[index]?.type && touched.category?.category}
                                                                onChange={handleChange}
                                                                value={values.products_services[index]?.type}
                                                                className={'signup__input inputField_container_input  '}
                                                            >
                                                                <option value="" disabled hidden>Select type
                                                                </option>
                                                                {
                                                                    optionList.map((type, typeIndex) => (
                                                                        <option key={'p_s_t_i' + type + typeIndex}
                                                                                value={type}>{type}</option>
                                                                    ))
                                                                }
                                                            </Field>
                                                            {/*<span id="--name__error"*/}
                                                            {/*      className="inputField_info_wrapper_message">{errors.category?.category && touched.category?.category && errors.category?.category}*/}
                                                            {/*</span>*/}
                                                        </div>

                                                        <InputField
                                                            id={`products_services[${index}].name`}
                                                            name={`products_services[${index}].name`}
                                                            type="text"
                                                            classname="signup__input"
                                                            placeholder={"Name"}
                                                            onblur={handleBlur}
                                                            // error={errors.products_services[index]?.type && touched.category?.years : null}
                                                            onchange={handleChange}
                                                            // message={errors.category?.years && touched.category?.years && errors.category?.years}
                                                            inputValue={values.products_services[index]?.name}
                                                            label={'Name'}
                                                        />

                                                        <TextAreaField
                                                            id={`products_services[${index}].description`}
                                                            name={`products_services[${index}].description`}
                                                            classname="signup__input"
                                                            placeholder={"Description"}
                                                            onblur={handleBlur}
                                                            // error={errors && errors.products_services[index]?.type && touched.category?.years}
                                                            onchange={handleChange}
                                                            // message={errors.category?.years && touched.category?.years && errors.category?.years}
                                                            inputValue={values.products_services[index]?.description}
                                                            label={'Description'}
                                                        />


                                                    </div>
                                                ))
                                                }
                                                <div className="add" onClick={() => push({
                                                    type: "",
                                                    name: "",
                                                    description: "",
                                                })}>+ Add More
                                                </div>
                                            </div>
                                        )
                                    }
                                }
                            </FieldArray>

                        </div>
                        <div className={'add-business-section_cta'}>
                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Next"}/>
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default ProductsAndServices;
